import Axios from '@/services/axios-instance/axios.service';

class DocumentsService {
  // Documents
  async getDocuments(req) {
    const { data } = await Axios.post('/documents/get-documents', req);
    return data;
  }
  async uploadDocumentToRequest(req) {
    const { data } = await Axios.post('/documents/upload-document', req);
    return data;
  }
  async deleteDocument(req) {
    const { data } = await Axios.post('/documents/delete-document', req);
    return data;
  }
  async downloadDocument(req) {
    const { data } = await Axios.post('/documents/view-document', req);
    return data;
  }
}

export default new DocumentsService();
